const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-file/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { FileListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-file/list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-file/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: FileListFilterParamSchema
});